// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { IEnvironment } from 'src/app/core/models/ienvironment.model';

export const environment: IEnvironment = {
  production: false,
  apiUrl: 'https://api.softoursistemas.com/regularesatmv',
  apiUrlSimulate: 'https://api.softoursistemas.com/regularesatmv/simulate',
  apiSiriUrl: 'https://api.softoursistemas.com/regulares',
  version: '',
  iconsPath: '/assets/icons',
  features: {},
  whitelistedDomains: ['localhost:4200', 'localhost:44371'],
  timezone: 'Europe/Madrid',
  subtractMinutes: 10,
  subtractSeconds: 0,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
